import { render, staticRenderFns } from "./MailDialog.vue?vue&type=template&id=2145e558&"
import script from "./MailDialog.vue?vue&type=script&lang=js&"
export * from "./MailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports